import axios from 'axios';
import { IPublicClientApplication } from "@azure/msal-browser";
import { apiRequest } from '../authConfig';
import { ApiUser } from './apiService';

const API_URL = `${process.env.REACT_APP_API_BASE_URL}/api/users`; 

const getAuthConfig = async (instance: IPublicClientApplication, account: any) => {
    const response = await instance.acquireTokenSilent({
        ...apiRequest,
        account: account
    });
    return {
        headers: {
            Authorization: `Bearer ${response.accessToken}`,
            'Content-Type': 'application/json'
        }
    };
};

export const getAllUsers = async (
  instance: IPublicClientApplication, 
  account: any
): Promise<ApiUser[]> => {
    try {
        const config = await getAuthConfig(instance, account);
        const response = await axios.get<ApiUser[]>(API_URL, config); 
        return response.data;
    } catch (error) {
        console.error("Error fetching all users:", error);
        throw error;
    }
};

export const getUserPermissions = async (
    instance: IPublicClientApplication,
    account: any,
    userId: number
): Promise<UserWithPermissions> => {
    try {
        const config = await getAuthConfig(instance, account);
        const response = await axios.get<UserWithPermissions>(`${API_URL}/${userId}/permissions`, config); 
        return response.data;
    } catch (error) {
        console.error(`Error fetching permissions for user ${userId}:`, error);
        throw error;
    }
}

export const addUserPermission = async (
    instance: IPublicClientApplication,
    account: any,
    permission: UserPermission
): Promise<any> => {
    try {
        const config = await getAuthConfig(instance, account);
        const response = await axios.post<UserWithPermissions>(`${API_URL}/permissions`, permission, config); 
        return response.data;
    } catch (error) {
        console.error("Error adding permission:", error);
        throw error;
    }
}

export const removeUserPermission = async (
    instance: IPublicClientApplication,
    account: any,
    permission: UserPermission
): Promise<any> => {
    try {
        const config = await getAuthConfig(instance, account);
        const response = await axios.delete<UserWithPermissions>(`${API_URL}/permissions`, {...config, params: permission}); 
        return response.data;
    } catch (error) {
        console.error("Error removing permission:", error);
        throw error;
    }
}

export interface UserPermission {
    userId: number;
    permissionType: string;
    permissionValue: string;
}

export interface UserWithPermissions extends ApiUser {
    userPermissions: UserPermission[];
    roleIds: number[];
    entityId: number | null;
}